<template>
    <div class="privacy-policy">
        <div class="tuk-icon" @click="goHome" />
        <div class="notification" @click="clicked">
            <div class="subtitle">
                TUK App Privacy Policy
            </div>
            <p>
                Effective date: July 1, 2021

                ALLOPATRA CO. LTD. ("us", "we", or "our") operates the TUK APP mobile application (hereinafter referred to
                as
                the "Service").

                This page informs you of our policies regarding the collection, use and disclosure ofpersonal data when you
                use our Service and the choices you have associated withthat data.

                We use your data to provide and improve the Service. By using the Service, you agreeto the collection and
                use of information in accordance with this policy. Unlessotherwise deﬁned in this Privacy Policy, the terms
                used in this Privacy Policy have thesame meanings as in our Terms and Conditions.

                Deﬁnitions

                ServiceService is the TUK APP mobile application operated by ALLOPATRA CO., LTD. Personal DataPersonal Data
                means data about a living individual who can be identiﬁedfrom those data (or from those and other
                information either in our possessionor likely to come into our possession). Usage DataUsage Data is data
                collected automatically either generated by the use of theService or from the Service infrastructure itself
                (for example, the duration of apage visit). CookiesCookies are small ﬁles stored on your device (computer or
                mobile device)

                Information Collection and Use

                We collect several different types of information for various purposes to provide andimprove our Service to
                you.

                Types of Data Collected

                Personal Data

                While using our Service, we may ask you to provide us with certain personallyidentiﬁable information that
                can be used to contact or identify you ("Personal Data").Personally identiﬁable information may include, but
                is not limited to:

                Mobile number
                Nick name
                Address location
                Email address
                Cookies and usage data
            </p>
            <!-- <br> -->
            <!-- <p class="button is-fullwidth is-danger" @click="emailDeleteMe">Delete This Account</p> -->
        </div>
        <span class="button is-link has-text-weight-medium" @click="goHome">Back to TUK</span>
    </div>
</template>


<script>
export default {
    name: "PrivacyPolicy",
    components: {
    },
    data() {
        return {
            emailAddress: "deleteme@tukapp.co",
            isClicked: false
        };
    },
    computed: {
        accountNumber() {
            return this.$store.getters.phoneNumber;
        },
        emailSubject() {
            return `DELETE ME [ ${this.accountNumber || 'unknown user'} ]`;
        },
        href() {
            return `mailto:${this.emailAddress}?subject=${this.emailSubject}`;
        }
    },
    mounted() {
    },
    activated() {
    },
    methods: {
        goHome() {
            this.$router.push("/home");
        },
        emailDeleteMe() {
            // this.isClicked = true;
            window.location.href = this.href;
        },
        clicked() {
            this.isClicked = true
            var name = this.$store.getters.realName;
            var msg = `💣 ${this.emailSubject} ${name}`
            this.sendSuperuserNotification(msg);
        }
    },
};
</script>

<style scoped>
.privacy-policy {
    background-color: #fac002;
    width: 100%;
    height: 100%;
}

.tuk-icon {
    background-image: url("../../public/img/icons/round-512x512.png");
    height: 150px;
    width: 150px;
    background-size: cover;
    margin-left: 20px;
}

.notification {
    margin: 20px;
    margin-top: 0;
    text-align: left;
    max-height: calc(100vh - 225px);
    overflow: scroll;
}
</style>